//import $ from 'jquery';
import slider from './slider.js';

const isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

export default function() {

    if(document.readyState === 'complete') {
        slider();
    }
    else {
        window.onload = function() {
            slider();
        };
    }

    // const $wrapper = $('.main-slider__items-wrapper');

    // if($wrapper.length) {
    //     $wrapper.slick({
    //         adaptiveHeight: true,
    //         autoplay: true,
    //         autoplaySpeed: 3500,
    //         arrows: false,
    //         appendDots: $('.main-slider').find('.wrapper'),
    //         dots: true,
    //         dotsClass: 'main-slider__paginator',
    //         infinite: true,
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         speed: 1000,
    //         fade: !isTouch
    //     });
    // }
}